export enum HIGHTLIGHT_CASES {
   DEFAULT =  'default',
   LINE_HOVERED = 'hovered line',
   SEARCHED_WORD = 'text of word == findText',
   SELECTED_LINE = 'selected line',
   SELECTED_WORD = 'selected word',
   WORD_HOVERED = 'hovered word' 
}

